module.exports = __webpack_public_path__ + "static/img/increment08.31d8102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/increment08.png
// module id = r/l/
// module chunks = 0